import React from 'react';

import { Platform, PLATFORM_BODY_ATTR } from 'app-constants';

interface Props {
    platform: Platform;
}

const PlatformProvider: React.FC<Props> = ({ children, platform }) => {
    const dynamicAttributes = {
        [PLATFORM_BODY_ATTR]: platform,
    };

    return <div {...dynamicAttributes}>{children}</div>;
};

export default PlatformProvider;
